export default __webpack_public_path__ + "static/media/main.cdcfe06f.jpg";